/**
 * Action creator for fetching the list of available resource types
 * (article / podcast / video / ...) that can be sent to a patient.
 *
 * Returns a react-fetching-library request descriptor — used with
 * useQuery in the invitation modal to populate the picker step.
 *
 * Endpoint: GET /accounts/:accountUuid/resources-data
 */
export const fetchResourceTypesAction = ({ accountUuid }) => ({
  method: 'GET',
  endpoint: `/accounts/${accountUuid}/resources-data`,
});
